module.exports = __webpack_public_path__ + "static/media/unlimited_km.662c362c.svg";